<template>
  <div>
    <el-container>
      <el-header height="15.8rem">
        <div class="header2 pc">
        <div class="inner">
            <p>
                <a href="https://www.jxrsrc.com/">
                    <img src="http://dlo.jxrsrc.com/img/logo.gif">
                </a>
            </p>
            <p>
                <a href="https://jxrsrc.com/member/login/personal">个人登录</a>
                <a href="https://jxrsrc.com/member/login/company">单位登录</a>
            </p>
        </div>
    </div>
        <!-- <div class="header red-header dark-theme" style="background: hsla(0,0%,100%,.9);">
          <div class="logo">
            <div class="logo2">

            <img src="@/assets/logo.png" alt="" class="dark-logo">
            </div>
          </div>
          <ul class="navigation-bar">
            <a class="active" @click="changeTab(0)" >
              <li class="navigation-item liability current-tab" :class="currentTab == 0 ? 'active2' : ''">活动介绍</li>
            </a>
            <a class="active" @click="changeTab(1)" >
              <li class="navigation-item liability current-tab" :class="currentTab == 1 ? 'active2' : ''">人才政策</li>
            </a>
            <a class="active" @click="changeTab(2)" >
              <li class="navigation-item liability current-tab" :class="currentTab == 2 ? 'active2' : ''">引才单位风采</li>
            </a>
            <a class="active" @click="changeTab(3)" >
              <li class="navigation-item liability current-tab" :class="currentTab == 3 ? 'active2' : ''">岗位信息</li>
            </a>
          </ul>
        </div> -->
        <div><img :src="banner" alt="" style="width:100%"/></div>
        
        <!-- <div class="banner2"></div> -->
        <div class="navigation">
          <ul id="nav1">
            <li>
              <a @click="changeTab(0)" :class="currentTab == 0 ? 'active' : ''"
                >活动介绍</a
              >
            </li>
            <li>
              <a @click="changeTab(1)" :class="currentTab == 1 ? 'active' : ''">
                人才政策
              </a>
            </li>
            <li>
              <a @click="changeTab(2)" :class="currentTab == 2 ? 'active' : ''"
                >引才单位风采</a
              >
            </li>
            <li>
              <a @click="changeTab(3)" :class="currentTab == 3 ? 'active' : ''"
                >岗位信息</a
              >
            </li>
          </ul>
        </div>
      </el-header>
      <el-main>
        <!-- 活动介绍 -->
        <div v-show="currentTab == 0">
          <div class="row2" style="margin-bottom:100px">
            <div class="imgc">嘉兴城市宣传片</div>
          </div>
          <div style="width:856px;height:480px;margin: 0 auto;margin-bottom:50px">
              <div>
                <AliPlayer ref="videoPlayer" :source="src[1]" height="480px" :cover="cover" />
                <div
                  style="
                    text-align: center;
                    font-size: 0.36rem;
                    margin-top: 0.2rem;
                  "
                >
                  
                </div>
              </div>
            </div>
          <div class="row2">
            <div class="imgc">活动介绍</div>
          </div>
          <div class="row">
            <div class="row2">
              <div class="imgt">
                <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
                <span>活动背景</span>
                  <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
              </div>
            </div>
            <p>
              为深入贯彻十九届六中全会和中央人才工作会议精神，认真落实省委、市委人才工作会议部署，加大博士后人才引进培养力度，为我市奋力打造世界重要人才中心和创新高地的战略节点，努力建设长三角金南翼最具创新活力的产才融合典范市、青创人才理想城、营智环境标杆地，为打造“重要窗口”中最精彩板块、建设共同富裕示范区的典范城市提供强大人才支撑。嘉兴市人力资源和社会保障局定于5月18日起开展2022年“嘉人有约 博揽众才”嘉兴博士后线上引才活动。本次活动通过线上投递简历形式，用人单位与博士毕业生、博士后研究人员开展对接洽谈。
            </p>
            <div class="row2">
              <div class="imgt">
                <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
                <span
                  >活动安排</span>
                  <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
              </div>
            </div>
            <p style="text-align: center; text-indent: 0px">
              简历投递：2022年5月18日—12月31日
            </p>
            <p style="text-align: center; text-indent: 0px">
              活动网址：嘉兴人事人才网（http://www.jxrsrc.com）
            </p>
            <div class="row2">
              <div class="imgt">
                <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
                <span
                  >参会对象</span>
                  <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
              </div>
            </div>
            <p style="text-align: center; text-indent: 0px">
              用人单位：嘉兴市各博士后工作站设站单位
            </p>
            <p style="text-align: center; text-indent: 0px">
              参会人才：海外及全国各高校博士毕业生及有来嘉做博士后研究意愿的人员
            </p>
          </div>
          <div class="row2" style="margin-top: 80px">
            <div class="imgc">引才公告</div>
          </div>
          <div class="row">
            <p style="margin-top: 50px">
              嘉兴地处浙江省东北部，整个地理版图犹如展开的“荷叶”，在这里，春秋的水、唐宋的镇、明清的建筑和现代的嘉兴人，每一眼风景、每一处生活、每一次奋斗，都是江南“醉”美时光。
            </p>
            <p style="margin-top: 50px">
              <span style="font-weight: bold"
                >嘉兴是一座交通便利、区位优势非常明显的城市。</span
              >嘉兴位于中国的东部，是中国共产党的诞生地，是世界互联网大会永久举办地。处于中国经济最活跃的长三角经济圈的核心区域，东接上海，西连杭州，北邻苏州，南跨钱塘江，下辖南湖、秀洲两个区，平湖、海宁、桐乡三个县级市，以及嘉善、海盐两个县。境内铁路、公路、水路四通八达，坐高铁到杭州、上海均不到半小时。
            </p>
            <p style="margin-top: 50px">
              <span style="font-weight: bold"
                >嘉兴是一座历史悠久、人文荟萃的文化名城。</span
              >嘉兴自古人杰地灵、人才辈出，境内马家浜文化遗址距今已有7000多年，近现代涌现出王国维、徐志摩、茅盾、丰子恺、陈省身、金庸等名师大家。嘉兴是全国文明城市、世界文化遗产城市、中国优秀旅游城市、国家卫生城市、国家园林城市、国家历史文化名城。
            </p>
            <p style="margin-top: 50px">
              <span style="font-weight: bold"
                >嘉兴是一座宜居宜业、绿色生态的品质之城。</span
              >既有天下第一潮的钱江潮等自然景观，也有乌镇、西塘等千年古镇和世界文化遗产京杭大运河等人文胜景。居住在嘉兴，既能体验现代城市的文明幸福，更能感受到
              “水乡绿城”的生态特征。嘉兴是一座非常开放、包容、友好的城市，“勤善和美”是嘉兴的人文基因，创建平安嘉兴、建设城市大脑、打造智安小区，努力实现“嘉兴无贼”。
            </p>
          </div>
          <div class="row">
            <p style="margin-top: 50px">
              <span style="font-weight: bold"
                >嘉兴也是一座充满活力的创新之城。</span
              >“勇猛精进”是嘉兴新时代的精神写照，当前嘉兴正走在经济高质量发展的道路上，正在建设长三角区域先进制造业基地、数字经济高地和高质量外资集聚地。半导体、生物医药、航空航天等一批新兴产业板块也正在加速崛起。2020年，嘉兴获评央视发布的全国“经济活跃城市”营商环境综合排名前20位、全省第二。
            </p>
          </div>
          <div class="row">
            <p style="margin-top: 50px">
              <span style="font-weight: bold"
                >嘉兴更是一座吸引人才创业创新的优选之城。</span
              >近年来，嘉兴大力实施“创新嘉兴·精英引领计划”、硕博倍增计划、大学生“550”引才计划等一系列人才政策。更新迭代博士后资助政策，给予博士后两年50万元的科研生活补助，并对出站留嘉（来嘉）工作的再给予20万元的生活补助。目前，嘉兴共建立博士后工作站117家，在站博士后167人，与清华大学、浙江大学、上海交通大学、同济大学、苏州大学等全国40余所高校开展博士后联合培养。
            </p>
          </div>
          <div class="row">
            <p style="margin-top: 50px">
              今天的嘉兴，青年人才加速汇聚，创业创新活力无限。未来的嘉兴，必将成为海内外人才的集聚高地、科创产业融合发展的“实验场”、青年创业创新的“梦工场”。我们热忱欢迎广大人才来禾，成为嘉兴城市发展的合伙人和见证者。我们热切期待在最红的地方遇见最好的你！我们在“嘉”等你！
            </p>
          </div>
        </div>
        <!-- 人才政策 -->
        <div v-if="currentTab == 1">
          <div class="row2">
            <div class="imgc">人才政策</div>
          </div>
          <div class="row2">
            <div class="imgt" style="display: flex; justify-content: center">
              <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
              <div style="margin: 0 60px">
                <div style="color: #000; font-weight: 700; margin-top: 40px">
                  嘉兴博士后资助政策
                </div>
              </div>
              <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
            </div>
          </div>
          <div
            class="row"
            style="border-bottom: 1px solid #e3e3e3; text-align: left"
          >
            <img src="@/assets/hdjs/tit1.png" style="width:50px;margin-top: 0.2rem;" />
            <p style="margin-bottom: .8rem">
              对新建国家级博士后工作站（流动站）、省级博士后工作站，分别给予<span
                style="color: #f31a19;font-size:30px"
                >100</span
              >万元和<span style="color: #f31a19;font-size:30px">50</span>万元的建站补助。
            </p>
          </div>
          <div
            class="row"
            style="border-bottom: 1px solid #e3e3e3; text-align: left"
          >
            <img src="@/assets/hdjs/tit2.png" style="width:50px;margin-top: 0.2rem;" />
            <p style="margin-bottom: .8rem">
              对取得独立招收博士后研究人员资格的单位给予<span
                style="color: #f31a19;font-size:30px"
                >100</span
              >万元的奖励。
            </p>
          </div>
          <div
            class="row"
            style="border-bottom: 1px solid #e3e3e3; text-align: left"
          >
            <img src="@/assets/hdjs/tit3.png" style="width:50px;margin-top: 0.2rem;" />
            <p style="margin-bottom: .8rem">
              对新招收的博士后研究人员，每年给予不低于<span
                style="color: #f31a19;font-size:30px"
                >25</span
              >万元的科研生活补助，资助期2年。
            </p>
          </div>
          <div
            class="row"
            style="border-bottom: 1px solid #e3e3e3; text-align: left"
          >
            <img src="@/assets/hdjs/tit4.png" style="width:50px;margin-top: 0.2rem;" />
            <p style="margin-bottom: .8rem">
              对出站留嘉（来嘉）工作的博士后给予最高<span style="color: #f31a19;font-size:30px"
                >20</span
              >万元的生活补助。同时享受博士<span style="color: #f31a19;font-size:30px">35</span
              >万元购房补贴、<span style="color: #f31a19;font-size:30px">6</span>
              万元生活补贴、<span style="color: #f31a19;font-size:30px">1000</span
              >元/月工资外津贴、<span style="color: #f31a19;font-size:30px">60</span
              >万元住房公积金贷款。
            </p>
          </div>
          <div
            class="row"
            style="border-bottom: 1px solid #e3e3e3; text-align: left"
          >
            <img src="@/assets/hdjs/tit5.png" style="width:50px;margin-top: 0.2rem;" />
            <p style="margin-bottom: .8rem">
              博士后科研流动站、工作站出站人员，在站期间能够圆满完成研究课题，并取得科研成果的，可直接确认相应的高级职称。
            </p>
          </div>

          <div class="row2">
            <div class="imgt" style="display: flex; justify-content: center">
              <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
              <div style="margin: 0 60px">
                <div style="color: #000; font-weight: 700; margin-top: 40px">
                  各县（市、区）博士后资助政策
                </div>
              </div>
              <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
            </div>
          </div>
          <!-- <div class="row" style="margin-top: 60px; text-align: left">
            <img src="@/assets/hdjs/nanhu.png" style="margin-left: 100px" />
            <div style="display: flex">
              <div
                style="
                  font-size: 16px;
                  color: #000;
                  font-weight: 700;
                  line-height: 30px;
                  text-indent: .8rem;
                  margin-top: 100px;
                "
              >
                对新招收的博士后研究人员，每年给予不低于25万元的科研生活补助，资助期2年。对出站留嘉（来嘉）工作的博士后给予最高20万元的生活补助。
              </div>
              <img src="@/assets/hdjs/1.png" style="margin-top: -111px" />
            </div>
          </div> -->
        <div class="outline">
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/1.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>南湖区</h3></div>
              <span class="content">对新招收的博士后研究人员，每年给予不低于25万元的科研生活补助，资助期2年。对出站留嘉（来嘉）工作的博士后给予最高20万元的生活补助。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/2.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>秀洲区</h3></div>
              <span class="content">对新招收的博士后研究人员，每年给予不低于25万元的科研生活补助，资助期2年。对出站留嘉（来嘉）工作的博士后给予最高20万元的生活补助。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/3.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>经开区</h3></div>
              <span class="content">对新招收的博士后研究人员，每年给予不低于25万元的科研生活补助，资助期2年。对出站留嘉（来嘉）工作的博士后给予最高20万元的生活补助。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/4.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>嘉善县</h3></div>
              <span class="content">对进站的博士后研究人员，给予15万元进站科研经费补助。对于全职博士后研究人员，给予每人每年15万元日常经费资助，资助2年；在职博士后研究人员，给予每人每年8万元日常经费资助，资助2年。对顺利出站的博士后给予10万元出站科研奖励。对于期满出站并留善全职工作的博士后，给予设站单位最高20万元的引才补贴。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/5.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>平湖市</h3></div>
              <span class="content">新招收一名博士后研究人员，每年给予工作站25万元科研生活补助（其中给予个人的生活补助不少于50%），资助期2年。对出站留平工作满一年的博士后研究人员给予20万元的生活补助。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/6.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>海盐县</h3></div>
              <span class="content">对新招收的博士后研究人员，每年给予不低于25万元的科研生活补助，资助期2年。对出站留盐（来盐）工作的博士后给予最高20万元的生活补助。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/7.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>海宁市</h3></div>
              <span class="content">对博士后科研工作站新招收世界排名前200名以及国内“双一流”高校的全职博士后研究人员，给予20万元科研经费和每年20万元生活经费资助，对新招收的其他全职博士后研究人员，给予10万元科研经费和每年15万元生活经费资助，资助期最长3年，在职博士后生活经费资助减半。出站后全职留在海宁工作的，自留用当月起依法连续缴纳社会保险满6个月、满24个月和满36个月的，每次分别给予10万元留用奖励。</span>
            </div>
          </div>
          <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/8.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>桐乡市</h3></div>
              <span class="content">对新招收的博士后研究人员给予每年25万元的科研生活补助，补助时间不超过2年。出站后首次就业在桐乡市的，全职在岗工作且已连续缴纳社会保险满6个月，可申请10万元的出站生活补助，全职在桐乡市工作满3年，可再申请10万元的出站生活补助。</span>
            </div>
          </div>
           <div class="item-wrapper">
            <div class="image-wrapper">
              <img src="@/assets/hdjs/9.jpg" alt="" class="image">
            </div>
            <div class="item">
              <div class="title-wrapper"><h3>港区</h3></div>
              <span class="content">对新招收博士后研究人员的，每年给予每名博士后研究人员25万元的科研生活补助，资助期2年。出站后首次就业在港区的，全职在岗工作且已连续缴纳社会保险满6个月，可申请10万元的出站生活补助，全职在桐乡市工作满3年，可再申请10万元的出站生活补助。</span>
            </div>
          </div>
        </div>
        </div>
        <!-- 引才单位风采 -->
        <div v-show="currentTab == 2">
          <div class="row2" style="padding-bottom: 2rem;">
            <div class="imgc">
              宣传视频
              <p
                style="
                  color: #333;
                  font-size: 24px;
                  font-weight: normal;
                  margin-top: 30px;
                "
              >
                (部分单位,排名不分先后)
              </p>
            </div>
          </div>
           
          <div class="videoBox">
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[9]"  :cover="cover9" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 嘉兴第一医院
                </div>
              </div>
            </div>
           <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[8]"  :cover="cover8" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 嘉兴第二医院
                </div>
              </div>
            </div>
           <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[11]"  :cover="cover11" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 清华柔电院
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[0]" :cover="cover1" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                  汇能生物
                </div>
              </div>
            </div>
            <!-- <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[1]" />
                <div
                  style="
                    text-align: center;
                    font-size: 0.36rem;
                    margin-top: 0.2rem;
                  "
                >
                  嘉兴城市宣传片
                </div>
              </div>
            </div> -->
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[2]"  :cover="cover2" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                  科峰生物
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[3]"  :cover="cover3" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                  万凯新材料
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[4]"  :cover="cover4" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 宇龙生物
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[5]"  :cover="cover5" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 晨光电缆
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[6]"  :cover="cover6" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 德沃康
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[7]"  :cover="cover7" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 华友钴业
                </div>
              </div>
            </div>
           
             <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[10]"  :cover="cover10" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 景兴纸业
                </div>
              </div>
            </div>
            
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[12]"  :cover="cover12" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 五芳斋
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[13]"  :cover="cover13" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 长盛轴承
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[14]"  :cover="cover14" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 诚达药业
                </div>
              </div>
            </div>
             <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[15]"  :cover="cover15" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 福莱新材料
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[16]"  :cover="cover16" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 田中精机
                </div>
              </div>
            </div>
            <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[17]"  :cover="cover17" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 巨石集团
                </div>
              </div>
            </div>
             <div class="boxList">
              <div class="video">
                <AliPlayer ref="videoPlayer" :source="src[18]"  :cover="cover18" />
                <div
                  style="
                    text-align: center;
                    font-size: 22.5px;
                    margin-top: 10px;
                  "
                >
                 嘉数公司
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentTab == 3">
          <div class="wrap-4-wrap">
            <div class="el-tabs el-tabs--top el-tabs--border-card">
              <div class="el-tabs__content">
                <div class="el-tab-pane" id="pane-first">
                  <div class="el-tab-pane">
                    <div
                      class="wrap-list wrap_list_new"
                      v-for="(item, index) in jobData"
                      :key="index"
                    >
                      <div class="enter-title">
                        <div class="enter-name enter_online_w">
                          <div
                            class="enter-name-list enter-name-list-title"
                            style="
                              font-size: 22px;
                              text-align: center;
                              margin-bottom: 0.5rem;
                              margin-top: 20px;
                            "
                          >
                            {{ item.name }}
                          </div>
                          <div class="enter-name-list five-list">
                            联系人：{{ item.contact }}
                          </div>
                          <div class="enter-name-list five-list" v-if="item.phone">
                            联系电话：{{ item.phone }}
                          </div>
                          <div class="enter-name-list five-list">
                            邮箱：{{ item.email }}
                          </div>
                        </div>
                      </div>
                      <div class="enter-detail">
                        <div class="enter-data">
                          <el-table
                            max-height="230"
                            :data="item.project"
                            border
                            style="width: 100%"
                          >
                            <el-table-column
                              prop="name"
                              label="科研项目"
                              width="180"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="profession"
                              label="专业方向"
                              width="180"
                            >
                            </el-table-column>
                            <el-table-column prop="num" label="需求人数">
                            </el-table-column>
                            <el-table-column prop="salary" label="年薪">
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                        <!-- <div class="enter-jobs">查看全部招聘需求</div> -->
                    </div>
                  </div>
                </div>

                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>

              </div>
            </div>
          </div>
        </div>
      </el-main>
       <el-footer>
        <div class="foot">
          <div style="margin-top:100px">
          <p>嘉兴东方人才服务公司 版权所有Copyright © 1999-2022 CNCHR. All rights reserved.</p>
          <p>网站备案:浙ICP备14023938号-1</p>
          <p>公网安备:浙公网安备 33040202000321号</p>
          </div>
        </div>
       </el-footer>
    </el-container>
  </div>
</template> 


<script>
/* eslint-disable */
import Vue from "vue";
// import VueVideoPlayer from "vue-video-player";
// import "video.js/dist/video-js.css";
// import "videojs-contrib-hls";
import cover from "@/assets/hdjs/cover.jpg";
import cover1 from "@/assets/hdjs/cover1.jpg";
import cover2 from "@/assets/hdjs/cover2.jpg";
import cover3 from "@/assets/hdjs/cover3.jpg";
import cover4 from "@/assets/hdjs/cover4.jpg";
import cover5 from "@/assets/hdjs/cover5.jpg";
import cover6 from "@/assets/hdjs/cover6.jpg";
import cover7 from "@/assets/hdjs/cover7.jpg";
import cover8 from "@/assets/hdjs/cover8.jpg";
import cover9 from "@/assets/hdjs/cover9.jpg";
import cover10 from "@/assets/hdjs/cover10.jpg";
import cover11 from "@/assets/hdjs/cover11.jpg";
import cover12 from "@/assets/hdjs/cover11.jpg";
import cover13 from "@/assets/hdjs/cover13.jpg";
import cover14 from "@/assets/hdjs/cover14.jpg";
import cover15 from "@/assets/hdjs/cover15.jpg";
import cover16 from "@/assets/hdjs/cover16.jpg";
import cover17 from "@/assets/hdjs/cover17.jpg";
import cover18 from "@/assets/hdjs/cover18.jpg";
import back1 from "@/assets/back1.jpg";
import back3 from "@/assets/back3.jpg";
import AliPlayer from "../component/AliPlayer.vue";
import { getJson } from "@/api/discoverydata";
import "@/icons/iconfont.js";
import banner from "@/assets/banner6.png";
import hnsw from "@/assets/hdjs/hnsw.mp4";
import jxcs from "@/assets/hdjs/jxcs.mp4";
import kfsw from "@/assets/hdjs/kfsw.mp4";
import wk from "@/assets/hdjs/wk.mp4";
import zjyl from "@/assets/hdjs/zjyl.mp4";
import cgdl from "@/assets/hdjs/cgdl.mp4";
import dwk from "@/assets/hdjs/dwk.mp4";
import hygy from "@/assets/hdjs/hygy.mp4";
import deyy from "@/assets/hdjs/deyy.mp4";
import dyyy from "@/assets/hdjs/dyyy.mp4";
import jxzy from "@/assets/hdjs/jxzy.mp4";
import qhrdy from "@/assets/hdjs/qhrdy.mp4";
import wfz from "@/assets/hdjs/wfz.mp4";
import cszc from "@/assets/hdjs/cszc.mp4";
import cdyy from "@/assets/hdjs/cdyy.mp4";
import flxc from "@/assets/hdjs/flxc.mp4";
import tzjj from "@/assets/hdjs/tzjj.mp4";
import zgjs from "@/assets/hdjs/zgjs.mp4";
import jsgs from "@/assets/hdjs/jsgs.mp4";
// Vue.use(
//   VueVideoPlayer
// );
// Vue.use(Lazyload, {
//   loading: zhanwei,
// });

export default {
  name: "PcIndex",
  components: { AliPlayer },
  data() {
    return {
      banner,
      cover,
      cover1,
      cover2,
      cover3,
      cover4,
      cover5,
      cover6,
      cover7,
      cover8,
      cover9,
      cover10,
      cover11,
      cover12,
      cover13,
      cover14,
      cover15,
      cover16,
      cover17,
      cover18,
      back3,
      back1,
      currentTab: 0,
      src: [hnsw, jxcs, kfsw, wk, zjyl,cgdl,dwk,
      hygy,deyy,dyyy,jxzy,qhrdy,wfz,cszc,cdyy,flxc,tzjj,zgjs,jsgs],
      jobData: [],
      total:0,
      pageSize:10,
      currentPage:1
    };
  },
  created() {},
  mounted() {
    // this.$refs.videoPlayer.initAliplayer()
    getJson({}).then((res) => {
      this.total = res.length
      // console.log('总数目'+this.total);
      // this.jobData = res;
      // console.log(this.jobData);
      for(let i = 0;i<10;i++){
        this.jobData.push(res[i])
      }
    });
  },
  computed: {
  },
  beforeDestroy() {
    // if (this.player) {
    //   this.player.dispose();
    // }
  },
  methods: {
    changeTab(i) {
      this.currentTab = i;
      // var el_container = document.getElementsByClassName("el-container")
      // if(i==2){
      //   el_container[0].style.backgroundImage = "url("+back3+")";
      // }
      // else{
      //   el_container[0].style.backgroundImage = "url("+back1+")";
      // }
    },
    handleCurrentChange(val){
      // console.log(val);
      let tempData = []
      // this.jobData = []
      getJson({}).then((res) => {
        if(this.total%10!==0&&(val==Math.ceil(this.total/10))){
          for(let i = (val-1)*10;i<((val-1)*10+this.total%10);i++){
            tempData.push(res[i])
          }  
            this.jobData = tempData
        }
        else{
          for(let j = (val-1)*10;j<val*10;j++){
            tempData.push(res[j])
          }
          this.jobData = tempData
        }
      
    });
    }
  },
};
</script>
<style>
.container {
  width: 100%;
  background: #f4f4f4;
}
.container {
  width: 100%;
  background: #f4f4f4;
}
.navigation {
  text-align: center;
  color: #000;
}
ul#nav1 {
  width: 100%;
  height: 80px;
  background: #cae2e5;
  margin: 0 auto;
}
ol,
ul {
  list-style: none;
}
ul#nav1 li {
  margin: 0 -3px;
  display: inline;
  height: 80px;
}
ul#nav1 li a {
  display: inline-block;
  padding: 0 130px;
  height: 80px;
  line-height: 80px;
  color: #6aafb7;
  font-family: "\5FAE\8F6F\96C5\9ED1";
  font-size: 30px;
  text-decoration: none;
  font-weight: 700;
  cursor: pointer;
}
.navigation ul#nav1 li a.active,
.navigation ul#nav1 li a:hover {
  color: #fff;
  background: #6aafb7;
}

.row {
  width: 100%;
  max-width: 1200px;
  min-width: 755px;
  margin: 0 auto;
  overflow: hidden;
  text-align: left;
}
.row2 {
  max-width: 1260px;
  min-width: 755px;
  margin: 0 auto;
  /* overflow: hidden; */
  text-align: center;
  
}
.row2 .imgt {
  margin: 1rem 0;
  font-size: 30px;
}
.row2 .imgt img {
  margin-bottom: -10px;
}
.row2 .imgt span {
  color: #000;
  font-weight: 700;
}
.row2 .imgc {
  margin: 0 auto;
  width: 400px;
  height: 114px;
  background: url(../../assets/hdjs/101b2ff9.png) no-repeat 50%;
  text-align: center;
  font-family: Courier New, Courier, monospace;
  font-size: 30px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  padding-top: 30px;
  margin-top: 80px;
  margin-bottom: 30px;
}
.row2 .video {
  max-width: 960px;
  min-width: 395px;
  margin: 0 auto;
  padding-top: 22px;
  padding-bottom: 120px;
}
.row p {
  line-height:40px;
  padding: 0 30px;
  text-indent: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei !important;
  color: #000;
}
.videoBox {
  display: grid;
  grid-template-columns: repeat(3, 350px);
  grid-template-rows: repeat(6, 250px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 120px;
}
.videoBox .video {
  max-width: 350px;
  margin: 0 auto;
  padding-top: 22px;
  /* padding-bottom: 120px; */
  /* padding-bottom: 50px; */
}
.wrap-4-wrap {
  /* margin: 0 0 .1rem; */
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}
.el-tabs--border-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
    0 0 6px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  /* height: 838px; */
}
.el-tabs--border-card > .el-tabs__content {
  padding: 15px;
}
.el-tabs__content {
  overflow: hidden;
  position: relative;
}
.wrap-4-wrap .el-tab-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
  justify-content: space-between;
}
.wrap-4-wrap .el-tab-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
}
.wrap-4-wrap .wrap-list {
  width: 575px;
  padding: 0.1rem;
  margin-right: 0.1rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  font-size: 0.3rem;
  border: 1px solid #6aafb7;
  background-color: #fff;
}
.wrap_list_new {
  background-color: #fff !important;
}
.wrap-4-wrap .wrap-list .enter-title {
  color: #3a3a3a;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.wrap-4-wrap .wrap-list .enter-name {
  /* width: 230px; */
  width: 100%;
  margin-left: 0.3rem;
  position: relative;
  color: #909090;
}
.enter_online_w {
  position: relative;
}
.wrap-4-wrap .wrap-list .enter-name .enter-name-list-title {
  font-size: 0.35rem;
  color: #6aafb7;
  font-weight: 600;
  height: 25px;
  width: 100%;
}
.wrap-4-wrap .wrap-list .enter-name .enter-name-list {
  margin-bottom: 0.1rem;
  font-size: 16px;
}
.wrap-4-wrap .wrap-list .enter-name .five-list {
  width: 50%;
  float: left;
}
.wrap-4-wrap .wrap-list .enter-detail {
  color: #909090;
  height: 250px;
  position: relative;
}
.wrap-4-wrap .wrap-list .enter-data {
  padding: 0.3125rem;
  padding-bottom: 0.5rem;
}
.wrap-4-wrap .wrap-list .enter-jobs {
  border: 0.0625rem solid #4fa9f6;
  width: 6rem;
  line-height: 3;
  margin: 0 auto;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
  color: #4fa9f6;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.wrap_list_new .enter-jobs {
  -webkit-box-shadow: 0 3px 3px #e5e5e5;
  box-shadow: 0 3px 3px #e5e5e5;
  background-color: #4fa9f6;
  color: #fff !important;
}
.wrap-4-wrap .wrap-list .enter-name .five-list {
  width: 1000%;
  float: left;
  text-align: left;
}
.red-header {
    z-index: 100;
}
.header {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 70px;
    font-size: 16px;
    font-family: PingFang SC,Helvetica,Arial,sans-serif;
    font-weight: 500;
    min-width: 1350px;
}
.header .navigation-bar {
    list-style-type: none;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin: 0 76px 0 0;
    padding: 0;
    min-width: 1080px;
    width: 100%;
}
.dark-theme .navigation-bar .active {
    color: #000;
}
.header .navigation-bar .active {
    margin-left: 58px;
}
.active {
    text-decoration: none;
}
.dark-theme .navigation-bar .navigation-item {
    position: relative;
}
.header .navigation-bar .navigation-item {
    cursor: pointer;
    margin: 0;
}
.dark-theme .navigation-bar .current-tab:before {
    visibility: visible;
    transform: translateX(0);
    opacity: 1;
}
.dark-theme .navigation-bar .navigation-item:before {
    position: absolute;
    bottom: -10px;
    visibility: hidden;
    content: "";
    width: 100%;
    height: 2px;
    background-color: hsla(0,0%,100%,.5);
    transform: translateX(-100%);
    border-radius: 2px;
    opacity: 0;
}
.el-header{
  padding: 0 !important;
}
.header .logo {
    height: 25px;
    margin-left: 91px;
    display: flex;
    align-items: center;
}
.header .logo .logo2 {
    cursor: pointer;
    margin-top: 1px;
    width: 150px;
    height: 62px;
    position: relative;
}
.header .logo .logo2 img {
    position: absolute;
    width: 100%;
    height: 100%;
}
.banner2{
    width: 100%;
    height: 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(../../assets/banner2.png);
    /* box-shadow: 0 16px 36px 4px rgba(255, 255, 255, .7); */
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #6aafb7 !important;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li:hover {
    color: #6aafb7 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    
    color: #FFF !important;
}
.outline {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding-top: 1rem;
}
.item-wrapper {
    width: 940px;
    height: 198px;
    flex-direction: row;
    background-color: #fff;
    margin: 0 0 58px;
    cursor: pointer;
}
.item-wrapper, .outline {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.item-wrapper .image-wrapper {
    height: 100%;
}
.item-wrapper .image-wrapper .image {
    width: 310px;
    height: 100%;
    object-fit: cover;
}
.item-wrapper .item {
    margin: 0 0 0 36px;
    padding-right: 30px;
    height: 189px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}
.item-wrapper .item .title-wrapper {
    margin: 10px 0 0;
    font-size: 20px;
    color: #000;
}
.item-wrapper .item .content {
    color: #666;
    line-height: 24px;
    width: 581px;
    /* height: 48px; */
    overflow: hidden;
    text-align: left;
    font-size: 15px;
    margin-top: 0.3rem;
}
.foot{
    margin-top: 20px;
    height: 288px;
    background-image: url(../../assets/footer.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    font-size: 12px;
    color: #9f9f9f;
    padding: 15px;
    font-size: 16px;
}
.foot p{
  line-height: 25px;
}
.el-footer{
  padding:0 !important;
}
.el-container{
    background-image: url(../../assets/back1.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.header2 {
    display: flex;
    justify-content: center;
    background-color: #fff;
}
.header2 .inner {
    display: flex;
    justify-content: space-between;
    width: 2500px;
    padding: 15px 0;
    margin: 0 auto;
}
.header2 p {
    display: flex;
}
.header2 p a {
    display: flex;
    height: 40px;
}
.header2 p a img {
    width: auto;
    height: 40px;
}
.header2 p {
    display: flex;
}
.header2 p + p a {
    padding: 0 15px 0 12px;
    background-color: #f2f2f2;
    font-size: 14px;
    color: #333;
    line-height: 40px;
}
.header2 p + p a:nth-child(1):before {
    background: url(http://dlo.jxrsrc.com/zph2022/20220318/img/user_ico01.png) no-repeat center;
}
.header2 p + p a:nth-child(2):before {
    background: url(http://dlo.jxrsrc.com/zph2022/20220318/img/user_ico02.png) no-repeat center;
}
.header2 p + p a:before {
    content: '';
    display: flex;
    width: 16px;
    height: 16px;
    margin: 12px 8px 12px 0;
}
@media all and (max-width: 767px) {
    .el-header {
        height: 395px !important;
    }
    .navigation ul#nav1 li a{
      padding: 0 10px;
    }
    .videoBox {
    display: grid;
    grid-template-columns: repeat(2, 350px);
    grid-template-rows: repeat(9, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    justify-content: center;
    padding-bottom: 120px;
}
}
@media all and (min-width: 768px) and (max-width: 1170px) {
  .videoBox {
    display: grid;
    grid-template-columns: repeat(2, 350px);
    grid-template-rows: repeat(9, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    justify-content: center;
    padding-bottom: 120px;
}
    .el-header {
        height: 395px !important;
    }
    .navigation ul#nav1 li a{
      padding: 0 30px;
    }
}

@media all and (min-width: 1171px) and (max-width: 1570px) {
    .navigation ul#nav1 li a{
      padding: 0 80px;
    }
     .el-header {
        height: 500px !important;
    }
}
@media all and (min-width: 1571px) and (max-width: 1990px) {
     .el-header {
        height: 610px !important;
    }
}
@media all and (min-width: 1991px) and (max-width: 2080px) {
     .el-header {
        height: 650px !important;
    }
}
</style>
